export default "__VITE_ASSET___OFnQEXL__"